import React from 'react';

import { TextStyled } from './Text.styled';

export const Text = ({
  children,
  inactive,
  breakWords,
  noData,
  fontSize,
}: any) => (
  <TextStyled
    breakWords={breakWords}
    inactive={inactive}
    noData={noData}
    fontSize={fontSize}
  >
    {children}
  </TextStyled>
);
